import React, { useEffect, useRef, useState } from 'react';

interface Props {
    className?: string;
    title: string;
    list: string[];
}

const Trusted: React.FC<Props> = ({ className, title, list }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const [filledList, setFilledList] = useState<string[]>([]);

    useEffect(() => {
        if (!containerRef.current || list.length === 0) return;
        const GAP = 12;
        const update = () => {
            const containerWidth = containerRef.current!.offsetWidth;
            let cardWidth = 350;
            if (containerWidth <= 1024) {
                cardWidth = 120;
            }

            const itemFullWidth = cardWidth + GAP;
            const singleWidth = list.length * itemFullWidth;

            let duplicatedCount = 2;
            while (singleWidth * duplicatedCount < containerWidth * 2) {
                duplicatedCount++;
            }
            const duplicated = Array.from({ length: duplicatedCount }, () => list).flat();
            setFilledList(duplicated);
            contentRef.current?.style.setProperty('--move-distance', `${singleWidth}px`);
            contentRef.current?.style.setProperty('--move-duration', `${list.length * 5}s`);
        };

        update();
        const ro = new ResizeObserver(update);
        ro.observe(containerRef.current);
        return () => ro.disconnect();
    }, [list]);

    return (
        <div className={`trusted-container ${className || ''}`}>
            <div className="trusted-title">{title}</div>
            <div className="trusted-list" ref={containerRef}>
                <div className="trusted-track" ref={contentRef}>
                    {filledList.map((src, index) => (
                        <div className="trusted-item" key={index}>
                            <img src={src} alt="" loading="lazy" />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Trusted;
